import React, { useContext } from "react";
import Typography, { TypographyProps } from "@common/components/Typography";
import { getStatusSxColorFn } from "@common/components/ListDetailViews/DetailView/DeviceCard/const";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import { Device } from "@services/devices/types";
import { useTranslation } from "react-i18next";
import { getStatusLabel } from "./const";
import { SxProps } from "@mui/material";

const verticalSx: SxProps = {
  textOrientation: "upright",
  writingMode: "vertical-lr",
};
const horizontalSx: SxProps = {
  marginBottom: "-1px",
};
const CardFooter = ({
  sx,
  device,
  landscape = false,
  ...props
}: TypographyProps & {
  device?: Pick<Device, "id">;
  landscape?: boolean;
}) => {
  const { detail } = useContext(RoomsRealtimeContext);
  const { t } = useTranslation();
  const [status, label] = getStatusLabel(device, detail?.meeting);

  return (
    <Typography
      variant="caption"
      fontSize="medium"
      {...props}
      sx={[
        ...(Array.isArray(sx) ? sx : [sx]),
        {
          backgroundColor: getStatusSxColorFn(status),
          textTransform: "uppercase",
        },
        landscape ? verticalSx : horizontalSx,
        { textAlign: "center" },
      ]}
    >
      {t(label)}
    </Typography>
  );
};

export default CardFooter;
